
export const setAbErrMsg = (temp_state) => {
    temp_state.errMsg = "";
    if ( temp_state?.details?.expertiseAndSpecialites?.data === "" ) {
        temp_state.errMsg = "Please expertise & specialties";
    }

    temp_state["isGenBioBtnDisabled"] = temp_state.errMsg !== "";
};

export const abFormBody = ({ propState, userDetails }) => {
    const bodyobj = {
        order_id: propState["order_id"],
        prompt_type: "realtor_bio",
        form_schema: {},
        name: userDetails?.name || "",
        email: userDetails?.email || "",
    };

    // name
    bodyobj.form_schema["name"]=userDetails?.name || ""

    // Radio Select
    for (const radioKey in propState['radioCont']) {
        bodyobj.form_schema[radioKey]=propState['radioCont'][radioKey]["selectedItem"]
    }

    // Pronouns
    bodyobj.form_schema["preferredPronoun"]=""
    if (bodyobj.form_schema["pointOfView"] === "Third person") {
        bodyobj.form_schema["preferredPronoun"]=propState["preferredPronoun"]["selectedItem"];
    }

    // Organization
    if (propState["organization"]) {
        bodyobj.form_schema["organization"] = propState["organization"];
    }

    // Main Points/Details
    for (const key in propState["details"]) {
        if (propState["details"][key]["data"]) {
            bodyobj.form_schema[key] = propState["details"][key]["data"];
        }
    }
    

    return bodyobj;
};

export const abRepopulate = (temp_state, data) => {

    temp_state.order_id=data.order_id
    let form_schema = data?.form_schema;

    for (const key in temp_state.radioCont) {
        temp_state.radioCont[key]["selectedItem"]=form_schema[key]
    }

    temp_state.preferredPronoun["title"]=temp_state.preferredPronoun["selectedItem"]=form_schema.preferredPronoun

    temp_state.organization=form_schema.organization

    for (const key in temp_state.details) {
        temp_state.details[key]["data"]=form_schema[key]
    }

    temp_state.pageType="Generated Section"
    temp_state.repopulate=true;
    temp_state.bioGenerated = abFormat(data?.descriptions);
};

// Helper function for formatting response

export const abFormat =(responseArr) =>{
    return responseArr.map((resObj, i) => {
        // reducer description schema
        return {
            status: "Just now",
            description_generated: resObj?.description_generated || "",
            editedDesc: resObj?.description_generated || "",
            isEditing: false,
            isEdited: resObj?.is_edited || false,
            like_status: resObj?.like_status,
            generated_at: resObj?.updatedAt || "",
            gen_id: resObj.gen_id,
            rewrite_count:resObj?.rewrite_count || 0
        };
    });
}

// Helper fuction to check action response

export const abCheckActRes =(res, action)=> {
    let descObj = res?.data[action.payload.descInd];
    if (res?.status !== "success") {
        return false;
    }
    if (res?.data.length === 0) {
        return false;
    }
    if (descObj["gen_id"] !== action.payload.gen_id) {
        return false;
    }
    Object.keys(action.payload.actionInfo).forEach((actKey) => {
        if (descObj[actKey] !== action.payload.actionInfo[actKey]) {
            return false;
        }
    });

    return true;
}

